import { Offcanvas } from "react-bootstrap";
import { CommonAddTaskTab } from "../Task/CommonAddTaskTab";
import { CommonAddLogHours } from "../CommonAddLogHour";
import { AddProjectComponent } from "../../../pages/projects/Project";
import { AddMilestoneComponent } from "../../../pages/milestones/Milestone";
import { CommonAddIssue } from "../Issue/CommonAddIssue";
import { useEffect, useRef, useState } from "react";
import { filterEntities } from "../../../apis/apiService";
import { useFetchIssueModuleQuery, useFetchMilestoneModuleQuery, useFetchTimesheetModuleQuery, useFetchUserInfoQuery} from "../../../slice/logdetailSlice";
import { useSelector } from "react-redux";
import { IconButton, Tooltip } from "@mui/material";
import { CgMenuGridO } from "react-icons/cg";
import { MdAssignment } from "react-icons/md";
import milestoneImage from "../../../assets/images/Header/MilestoneIcon.png";
import IssueImage from "../../../assets/images/Header/issue image.png";
import TimesheetImage from "../../../assets/images/Header/Timesheet.png";
// import BudgetImage from "../../../assets/images/Header/Budget.png";
import TaskImage from "../../../assets/images/Header/Task.png";
// import SettingsImage from "../../../assets/images/Header/Settings Icon.png";
// import DashboardImage from "../../../assets/images/Header/Dashboard.png";
import { useTheme } from "../../../ThemeContext";


export const HeaderCirclePlusMultiComponents = () => {
  const { isDarkMode } = useTheme();
  const [showComponentNames, setShowComponentNames] = useState("timelog");
  const [showTimelog, setShowTimelog] = useState(false);
  const [showMinipOPuP, setShowMiniPopUp] = useState(false);
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  // console.log("login_user in task:", login_user);
  const { role: login_user_role } = login_user || {};
  useFetchIssueModuleQuery({
    view_type_id: 1,
    searchText: "",
  });

  const project_span = useSelector((state) => state.selectOptions?.timesheetProjectSpan);
  const from_date = useSelector((state) => state.selectOptions?.timesheetFromDate);
  const to_date = useSelector((state) => state.selectOptions?.timesheetToDate);

  // console.log("notification_list:", notification_list);
  // const handleClickOpen = () => {
  //   setOpen(true); // Open the dialog
  // };

  const handleShowProject = () => {
    // dispatch(setShowProjectPopup(true));
    setShowTimelog((prev) => !prev);
  };

  // const { data: user_list_info, refetch: user_list_info_refetch } =
    useFetchUserInfoQuery();

  // const { data, error, isLoading, refetch, isError } =
    useFetchTimesheetModuleQuery({
      project_span: project_span,
      from_date: from_date,
      to_date: to_date,
      view_type: "all",
    });
  // const {
  //   data: milestone_module,
  //   refetch: milestone_module_refetch,
  //   isLoading: milestone_module_loading,
  // } = 
  useFetchMilestoneModuleQuery({
    searchText: "",
    view_type_id: 1,
  });

  const fetchTaskModule = async () => {
    const requestedData = {
      view_type_id: 1,
    };
    try {
      await filterEntities("tasks/show/all", requestedData);
    } 
    catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };

  //   const handleShowProject = () => {
  //     // dispatch(setShowProjectPopup(true));
  //     setShowTimelog((prev) => !prev);
  //   };

  const CommonShowPopup = (name) => {
    setShowMiniPopUp((prev) => !prev);
    if (name === "task") {
      // setShowTaskComponent(true);
      // setShowTimelogComponent(false);
      setShowComponentNames("task");
    } 
    else if (name === "timelog") {
      setShowComponentNames("timelog");
    } 
    else if (name === "issue") {
      setShowComponentNames("issue");
    } 
    else if (name === "project") {
      setShowComponentNames("project");
    } 
    else if (name === "milestone") {
      setShowComponentNames("milestone");
    }
  };
  const popupRef = useRef(null);

  // Close mini popup on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        showMinipOPuP
      ) {
        setShowMiniPopUp(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMinipOPuP]);

  return (
    <div>
      <Offcanvas
        show={showTimelog}
        placement="end"
        style={{ width: "55%" }}
        onHide={() => setShowTimelog(false)}
      >
        <Offcanvas.Body
          className="p-0 position-relative"
          style={{
            maxHeight: "100vh",
            overflowY: "auto",
          }}
        >
          {/* Top Icon Button */}
          <div
            className="position-absolute"
            style={{
              top: "16px",
              right: "20px",
              zIndex: 1000,
            }}
          >
            <CgMenuGridO
              fontSize={25}
              style={{ cursor: "pointer" }}
              onClick={() => setShowMiniPopUp((prev) => !prev)}
            />
          </div>

          {/* Mini Popup Grid (Nested Inside the First Offcanvas) */}
          {showMinipOPuP && (
            <div
              className="position-absolute bg-white shadow rounded p-3 z-50 floating-menu-inside-drawer"
              ref={popupRef}
              style={{
                top: "55px",
                right: "20px",
                width: "260px",
                border: "1px solid #ddd",
              }}
            >
              <div className="row text-center">
                {/* Only hide for employee login to add project */}
                {login_user_role !== "EMPLOYEE" && (
                  <div
                    className="col-4 mb-3"
                    onClick={() => CommonShowPopup("project")}
                  >
                    <Tooltip title="Projects">
                      <div className="commonCircle">
                        <MdAssignment color="rgb(15, 163, 141)" size={30} />
                      </div>
                    </Tooltip>
                    <div>Project</div>
                  </div>
                )}

                <div
                  className="col-4 mb-3"
                  onClick={() => CommonShowPopup("task")}
                >
                  <Tooltip title="Tasks">
                    <div className="commonCircle">
                      <img src={TaskImage} alt="Task" width={24} height={24} />
                    </div>
                  </Tooltip>
                  <div>Task</div>
                </div>

                <div
                  className="col-4 mb-3"
                  onClick={() => CommonShowPopup("issue")}
                >
                  <Tooltip title="Issues">
                    <div className="commonCircle">
                      <img
                        src={IssueImage}
                        alt="Issue"
                        width={24}
                        height={24}
                      />
                    </div>

                  </Tooltip>
                  <div>Issue</div>
                </div>
                <div
                  className="col-4 mb-3"
                  onClick={() => CommonShowPopup("timelog")}
                >
                  <Tooltip title="Timesheet">
                    <div className="commonCircle">
                      <img
                        src={TimesheetImage}
                        alt="Timesheet"
                        width={24}
                        height={24}
                      />
                    </div>
                  </Tooltip>

                  <div>Timelog</div>
                </div>
                <div
                  className="col-4 mb-3"
                  onClick={() => CommonShowPopup("milestone")}
                >
                  <Tooltip title="Milestones">
                    <div className="commonCircle">
                      <img
                        src={milestoneImage}
                        alt="Milestone"
                        width={24}
                        height={24}
                      />
                    </div>
                  </Tooltip>
                  <div>Milestone</div>
                </div>
              </div>
            </div>
          )}

          {/* Main Content Rendering Based on Selection */}
          <div className="p-2 position-relative min-vh-100 overflow-hidden">
            {showComponentNames === "task" && (
              <CommonAddTaskTab
                onCancel={handleShowProject}
                refetchList={() => {}}
                path_1="task"
                path_2="add"
                isModule={true}
              />
            )}
            {showComponentNames === "timelog" && (
              <CommonAddLogHours
                onApply={handleShowProject}
                onCancel={handleShowProject}
                span={project_span}
                fromDate={from_date}
                toDate={to_date}
                isModule={true}
                refetchList={() => {}}
                onAddAnother={() => setShowTimelog(true)}
              />
            )}

            {showComponentNames === "issue" && (
              <CommonAddIssue
                onCancel={handleShowProject}
                fetchIssues={() => {}}
                path="issue"
                isModule={true}
              />
            )}

            {showComponentNames === "project" && (
              <AddProjectComponent onCancel={handleShowProject} />
            )}
            {showComponentNames === "milestone" && (
              <AddMilestoneComponent
                onCancel={handleShowProject}
                fetchMilestone={() => {}}
              />
            )}
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      {login_user_role !== "CLIENT" && (
        <Tooltip title="Time Log" arrow open={showTimelog ? false : undefined}>
          <IconButton
            color="inherit"
            onClick={handleShowProject}
            sx={{
              "& img": {
                width: "22px",
                height: "22px",
                opacity: 0.6,
                filter: isDarkMode ? "brightness(0) invert(1)" : "brightness(0)",
                transition: "opacity 0.2s ease",
              },
              "&:hover": {
                backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.08)",
              },
              "&:hover img": {
                opacity: 1,
              }
            }}
          >
            <img
              src={TimesheetImage}
              alt="Time Log"
            />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );
};

export default HeaderCirclePlusMultiComponents;
